import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import ArgonDashboard from "./argon-dashboard";
import axios from 'axios';
import './assets/css/custom.css';
import { refreshTokenIfNeeded } from '@/utils/auth';




const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const runtimeConfig = await response.json();

    return {
      ...process.env,
      ...runtimeConfig
    };
  } catch (error) {
    console.error("Error loading runtime configuration:", error);
    return process.env;
  }
};

const configureAxios = (config) => {
  axios.defaults.baseURL = config.VUE_APP_BASE_URL || 'http://localhost:3000';
  axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  async (requestConfig) => {
    //console.log("AXIOS - INICIANDO VALIDACION");

    try {
      await refreshTokenIfNeeded();
    } catch (e) {
      console.error("Error en refreshTokenIfNeeded", e);
      throw e;
    }

    const token = store.state.auth.token;
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    //console.log("AXIOS - RETORNANDO");
    return requestConfig;
  },
  error => Promise.reject(error)
);
};













loadConfig().then((config) => {
  configureAxios(config);

  const appInstance = createApp(App);

  appInstance.use(Toast, {
    position: POSITION.TOP_RIGHT,
  });
  appInstance.use(store);
  appInstance.use(router);
  appInstance.use(ArgonDashboard);

  appInstance.config.globalProperties.$api = axios;
  appInstance.config.globalProperties.$version = config.VUE_APP_VERSION || 'v1.0.0';
  appInstance.config.globalProperties.$grafana_url = config.VUE_APP_GRAFANA_METRICS_URL || 'http://localhost';
  appInstance.config.globalProperties.$grafana_audit_url = config.VUE_APP_GRAFANA_AUDIT_URL || 'http://localhost';
  appInstance.config.globalProperties.$environment = config.VUE_APP_ENVIRONMENT || 'Developer';

  appInstance.mount('#app');
});
